import style from "./Header.module.css";
import { useContext, useState } from "react";
import { TechnologyContext } from "context/TechnologyContext";
import { AppContext } from "context/AppContext";

import IconClose from "assets/x.svg";
import { zapiszTechnologieUpdate } from "actions/zapiszTechnologieUpdate";
import { zapiszTechnologie } from "actions/zapiszTechnologie";
import DecodeToken from "pages/Login/DecodeToken";
import iconError from "assets/error.svg";

import { useArkusze } from "hooks/useArkusze";
import { useZamowienia } from "hooks/useZamowienia";
import axios from "axios";
import { IP } from "../../../../utils/Host";
import { skasujTechnologie } from "actions/skasujTechnologie";
import SprawdzBTN from "./SprawdzBTN";
import { useHistoria } from "hooks/useHistoria";
import { useProcesy } from "hooks/procesy/useProcesy";
import { zapiszTechnologieDodruk } from "actions/zapiszTechnologieDodruk";
import FormToPdf from "components/pdf/FormToPDF";
import { useArkuszeAuto } from "hooks/arkusze/useArkuszeAuto";
import {Folder, FolderOpenDot, LampFloor, LayoutGrid, LucideLampFloor, Menu } from 'lucide-react';
import { ModalInsertContext } from "context/ModalInsertContext";
import { useTechnologiaInsert } from "hooks/useTechnologiaInsert";
import MenuHeaderTech from "./menu_header_tech/MenuHeaderTech";



export default function Header({}) {
  const techContext = useContext(TechnologyContext);
  const appcontext = useContext(AppContext);
  const listaPapierow = appcontext.listaPapierow;
  const fechparametryTechnologii = techContext.fechparametryTechnologii;
    const contextModal = useContext(ModalInsertContext);
  const setOpenModalInsert = contextModal.setOpenModalInsert;

  const { createArkuszeFromElemenets, ponumerujArkusze } = useArkusze();

    const [showMenu, setShowMenu] = useState(false); // Stan do kontrolowania widoczności menu

const downloadJSON = () => {
  // 1. Tworzymy jeden zbiorczy obiekt, gdzie klucze to nazwy Twoich stanów
  const fullStateStructure = {
    technologie: techContext.daneTech,
    technologie_produkty: techContext.produktyTech,
    technologie_elementy: techContext.elementyTech,
    technologie_fragmenty: techContext.fragmentyTech,
    technologie_procesy_elementow: techContext.procesyElementowTech,
    technologie_arkusze: techContext.arkusze,
    technologie_legi: techContext.legi,
    technologie_legi_fragmenty: techContext.legiFragmenty,
    technologie_wykonania: techContext.wykonania,
    technologie_grupy_wykonan: techContext.grupaWykonan,
    technologie_realizacje: techContext.realizacje,
    technologie_oprawa: techContext.grupaOprawaTech,
    technologie_grupy_wykonan_oprawa: techContext.grupyOprawaAll,
    technologie_wykonania_oprawa: techContext.wykonaniaOprawy,
  };

  // 2. Konwertujemy CAŁY ten obiekt do jednego stringa JSON
  const jsonString = JSON.stringify(fullStateStructure, null, 2);
  
  // 3. Stworzenie Bloba z jednego, prawidłowego stringa
  const blob = new Blob([jsonString], { type: 'application/json' });
  
  // 4. Stworzenie tymczasowego linku do pobrania pliku
  const href = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = href;
  link.download = "state_export.json";
  
  // 5. "Kliknięcie" linku i posprzątanie
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};
  
  return (
    <header
      className={style.headerMain}
      onDoubleClick={async ()  => {
        console.clear();
        downloadJSON()
        // console.log("Dane Tech: ", techContext.daneTech);
        // console.log("Produkt Tech: ", techContext.produktyTech);
        // console.log("Elementy Tech:");
        // console.table( techContext.elementyTech);
        // console.log("Procesy Tech:");
        // console.table( techContext.procesyElementowTech);


        // console.log("Elementy Tech: ", techContext.elementyTech);
        // console.log("Fragmenty Tech: ", techContext.fragmentyTech);
        // console.log("Oprawa Tech: ", techContext.oprawaTech);
        // console.log("Procesy elementów tech: ", techContext.procesyElementowTech);
        // console.log("Procesy produktów tech: ", techContext.procesyProduktowTech);
        // console.log("Arkusze: ", techContext.arkusze);
        console.table(techContext.arkusze);
        console.table( techContext.legi);
        // console.log("Legi: ", techContext.legi);
        // console.log("Fragmenty leg tech: ", techContext.legiFragmenty);
        // console.log("Grupy wykonan tech: ", techContext.grupaWykonan);
        // console.table( techContext.grupaWykonan);
        // console.log("Wykonania tech: ", techContext.wykonania);
        // console.log("listaPapierow: ", appcontext.listaPapierow);
        // console.log("grupaOprawaTech: ", techContext.grupaOprawaTech);
        // console.table( techContext.procesyElementowTech);
        // console.table( techContext.procesyProduktowTech);
  


      }}
    >
      <LeftPane>
        <MenuHeaderTech showMenu={showMenu} setShowMenu ={setShowMenu}/>

        <button onClick={()=>{setShowMenu(!showMenu) }} style={{background:'transparent', border:'none'}}> 
       < Menu size={22} style={{color:'white',marginRight:'10px',marginLeft:'10px'}}/>
        </button>

        <p className={style.title2}> Technologia </p>
        <IconError />
        <p> {techContext.daneTech.id==1? <p className={style.new} >nowa</p>:<></>}</p>
        <p> {techContext.daneTech.stan==1? <p className={style.wstepna} >  wstępna</p>:<></>}</p>
      </LeftPane>

      <CenterPane>
        <AlertLega />
      </CenterPane>

      <RightPane>
            {/* <Arkusze /> */}
            {/* <FormToPdf/> */}
            {/* <Dodruk /> */}
            {/* <ZapisBtnPromiseDodruk /> */}
            {/* <PotwierdzKorekteZamowieniaBTN /> */}
            <SkasujTechnologieBTN />
            {/* <ClearBTN /> */}
            <SprawdzBTN />
            <ZapisBtnPromise />
            <IconNavigate  className={style.btn_x} logo={IconClose}  navi={"/Panel"}
            />
      </RightPane>
    </header>
  );
}



const ClearBTN = () => {
  const techContext = useContext(TechnologyContext);
  const setShowProcesy = techContext.setShowProcesy;
// if(DecodeToken(sessionStorage.getItem("token")).id ==1){
 if (DecodeToken(sessionStorage.getItem("token")).technologia_zapis == 1) {
    return (
    <button
      className={ style.btn}
      onClick={() => {

     

                      techContext.setArkusze([])
        techContext.setLegi([])
        techContext.setLegiFragmenty([])
        techContext.setGrupaWykonan([])
        techContext.setWykonania([])
        techContext.setGrupaOprawaTech([])

        setShowProcesy(false)
        
           

      }}
    >
      Clear 
    </button>
  );}
// }

};

const IconError = () =>{
  const techContext = useContext(TechnologyContext);
  const daneTech = techContext.daneTech;
  if(daneTech.korekta_zamowienia_alert ==1){
    return(
    <img
       className={style.iconError}
        src={iconError}
        onClick={() => {
        }}
        alt="Procesy"
      />
  )
  }
}



// const PotwierdzKorekteZamowieniaBTN = () => {
//   const techContext = useContext(TechnologyContext);
//   const daneTech = techContext.daneTech;
//   const setDaneTech = techContext.setDaneTech;
//  if (DecodeToken(sessionStorage.getItem("token")).technologia_zapis == 1) {

//     return (
//     <button
//       disabled={daneTech.korekta_zamowienia_alert == 1 ? false : true}
//       className={ daneTech.korekta_zamowienia_alert == 1 ? style.btn : style.btn_disabled  }
//       onClick={() => {
//         // daneTech.korekta_zamowienia_alert= null
//         setDaneTech({...daneTech, alert:true, korekta_zamowienia_alert: null})
      
//       }}
//     >
//       Potwierdź korekty
//     </button>
//   );
// }

// };










const ZapisBtnPromise = () => {
  const techContext = useContext(TechnologyContext);
  const isSaveButtonDisabled = techContext.isSaveButtonDisabled;
  const setSaveButtonDisabled = techContext.setSaveButtonDisabled;

  const daneTech = techContext.daneTech;
  const setDaneTech = techContext.setDaneTech;
  const produktyTech = techContext.produktyTech;
  const setProduktyTech = techContext.setProduktyTech;
  const elementyTech = techContext.elementyTech;
  const fragmentyTech = techContext.fragmentyTech;
  const oprawaTech = techContext.oprawaTech;
  const legi = techContext.legi;
  const legiFragmenty = techContext.legiFragmenty;
  const arkusze = techContext.arkusze;
  const grupaWykonan = techContext.grupaWykonan;
  const wykonania = techContext.wykonania;
  const procesyElementowTech = techContext.procesyElementowTech;

  const setLegiFragmenty = techContext.setLegiFragmenty;
  const setFragmentyTech = techContext.setFragmentyTech;
  const setElementyTech = techContext.setElementyTech;
  const setOprawaTech = techContext.setOprawaTech;
  const setLegi = techContext.setLegi;
  const setArkusze = techContext.setArkusze;
  const setGrupaWykonan = techContext.setGrupaWykonan;
  const setWykonania = techContext.setWykonania;
  const setProcesyElementowTech = techContext.setProcesyElementowTech;
  const grupaOprawaTech = techContext.grupaOprawaTech;
  const setGrupaOprawaTech = techContext.setGrupaOprawaTech;

  const fechparametryTechnologii = techContext.fechparametryTechnologii;

  const {zapiszTechnologiePool} = useTechnologiaInsert()

 if (DecodeToken(sessionStorage.getItem("token")).technologia_zapis == 1) {

  return (
    <button
      disabled={isSaveButtonDisabled}
      className={isSaveButtonDisabled ? style.btn_disabled : style.btn}
      onClick={() => {

    setSaveButtonDisabled(true)
        if(daneTech.id == 1){
        console.log("zapis 1st ");
        daneTech.autor_id = DecodeToken(sessionStorage.getItem("token")).id  

        zapiszTechnologiePool()
       
      }



        if(daneTech.id != 1){
              setSaveButtonDisabled(true)
          zapiszTechnologieUpdate({
         daneTech,
         setDaneTech,
         produktyTech,
         setProduktyTech,
         elementyTech,
         fragmentyTech,
         oprawaTech,
         legi,
         legiFragmenty,
         arkusze,
         grupaWykonan,
         wykonania,
         procesyElementowTech,
         setElementyTech,
         setFragmentyTech,
         setOprawaTech,
         setLegi,
         setLegiFragmenty,
         setArkusze,
         setGrupaWykonan,
         setWykonania,
         setProcesyElementowTech,
         setSaveButtonDisabled,
         grupaOprawaTech, setGrupaOprawaTech,
         fechparametryTechnologii

       });

}
       
        


      }}
    >
      Zapisz 
    </button>
  );
}
};
//----a
const ZapisBtnPromiseDodruk = () => {
  const techContext = useContext(TechnologyContext);
  const isSaveButtonDisabled = techContext.isSaveButtonDisabled;
  const setSaveButtonDisabled = techContext.setSaveButtonDisabled;

  const daneTech = techContext.daneTech;
  const setDaneTech = techContext.setDaneTech;
  const produktyTech = techContext.produktyTech;
  const setProduktyTech = techContext.setProduktyTech;
  const elementyTech = techContext.elementyTech;
  const fragmentyTech = techContext.fragmentyTech;
  const oprawaTech = techContext.oprawaTech;
  const legi = techContext.legi;
  const legiFragmenty = techContext.legiFragmenty;
  const arkusze = techContext.arkusze;
  const grupaWykonan = techContext.grupaWykonan;
  const wykonania = techContext.wykonania;
  const procesyElementowTech = techContext.procesyElementowTech;

  const setLegiFragmenty = techContext.setLegiFragmenty;
  const setFragmentyTech = techContext.setFragmentyTech;
  const setElementyTech = techContext.setElementyTech;
  const setOprawaTech = techContext.setOprawaTech;
  const setLegi = techContext.setLegi;
  const setArkusze = techContext.setArkusze;
  const setGrupaWykonan = techContext.setGrupaWykonan;
  const setWykonania = techContext.setWykonania;
  const setProcesyElementowTech = techContext.setProcesyElementowTech;
  const grupaOprawaTech = techContext.grupaOprawaTech;
  const setGrupaOprawaTech = techContext.setGrupaOprawaTech;

  const fechparametryTechnologii = techContext.fechparametryTechnologii;


 if (DecodeToken(sessionStorage.getItem("token")).technologia_zapis == 1) {

  return (
    <button
      disabled={isSaveButtonDisabled}
      className={isSaveButtonDisabled ? style.btn_disabled : style.btn}
      onClick={() => {


     
        console.log("zapis 1st ");
        daneTech.autor_id = DecodeToken(sessionStorage.getItem("token")).id  
        zapiszTechnologieDodruk({
          daneTech,
          produktyTech,
          elementyTech,
          fragmentyTech,
          oprawaTech,
          arkusze,
          legi,
          legiFragmenty,
          grupaWykonan,
          wykonania,
          procesyElementowTech,
          setProduktyTech,
          setDaneTech,
          setElementyTech,
          setFragmentyTech,
          setOprawaTech,
          setLegi,
          setLegiFragmenty,
          setArkusze,
          setGrupaWykonan,
          setWykonania,
          setProcesyElementowTech,setSaveButtonDisabled,
          grupaOprawaTech, setGrupaOprawaTech
        });
      

      }}
    >
      Zapisz Dodruk
    </button>
  );
}
};
//--
const LeftPane = ({ children }) => {

  return <div className={style.left}>{children}</div>;
};

const RightPane = ({ children }) => {
  return <div className={style.right}>{children}</div>;
};
const CenterPane = ({ children }) => {
  return <div className={style.center}>{children}</div>;
};




const AlertLega = () => {
  const techContext = useContext(TechnologyContext);
  const legiFragmenty = techContext.legiFragmenty;
  const even = (element) => element?.oprawa_id == null;

  if (legiFragmenty.some(even)) {
    return (
      <div className={style.center}>
        <p style={{ color: "red" }}>UWAGA: bezdomna lega!</p>
      </div>
    );
  }
};

const IconNavigate =  ({ className, logo, navi }) => {
  const techContext = useContext(TechnologyContext);
  const appContext = useContext(AppContext)
  const setShowTechnologyStage = techContext.setShowTechnologyStage;

  const fechGrupyAndWykonaniaForProcesor =
    techContext.fechGrupyAndWykonaniaForProcesor;
  const selectedProcesor = techContext.selectedProcesor;
  const {refZamPagination} = useZamowienia()
  return (
    <img
      className={className}
      src={logo}
      onClick={ async() => {
        setShowTechnologyStage(false);

        techContext.setRowZamowienia(null);
        techContext.setRowTechnologia(null);
        fechGrupyAndWykonaniaForProcesor(selectedProcesor);
        appContext.setIsLoading(true)

        
        await axios.put(IP + "setOrderClosed", {
          id: techContext.daneTech.zamowienie_id,
        });
        refZamPagination();
        appContext.setIsLoading(false)

        // techContext.setOpenTechnologia(false)
      }}
      alt="Logo"
    />
  );
};


const SkasujTechnologieBTN = () => {
    const techContext = useContext(TechnologyContext);

  const setShowTechnologyStage = techContext.setShowTechnologyStage;
  const daneTech = techContext.daneTech;
const {refZamPagination} = useZamowienia()

  

if(DecodeToken(sessionStorage.getItem("token")).technologia_zapis ==1){
if(techContext.grupaWykonan.length==0 & techContext.daneTech.id !=1){
      return (
    <button
      className={ style.btn}
      onClick={() => {
        skasujTechnologie(daneTech.id,daneTech.zamowienie_id,DecodeToken(sessionStorage.getItem("token")).id,refZamPagination,setShowTechnologyStage)

        // historia kasowanie zapisuje się po stronie bazy

        
      }}
    >
      Skasuj technologie
    </button>
  );
}

}

};
